// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1412": "03a31bbf2b6b","2908": "b171c2b21a96","4730": "edfc882b78b3","5845": "53c261b38964","8431": "6d5e058644c8",}[chunkId] + ".css"
}